<template>
  <list-layout :tableTools='toggleTableTools'>
    <template slot='header'>
      <BaseHeader :content='header' />
    </template>
    <template slot='table-core'>
      <base-table-pagination :total='pagination.total' :currentPage='pagination.currentPage'
        :perPage='pagination.pageSize' @changeCurrentPage='changeCurrentPage'
        @changePerPage='changePerPage'></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot='table-tags'>
      <base-table-filter-tags :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler"
        @saveTags="saveTagsHandler" />
    </template>
    <template slot='table-component'>
      <kendo-grid-component
        ref="grid"
        v-model="selected"
        :value-key="['idFacturae','idInvoice']"
        :include-key="['idCliente','idEstado','GrupoPropietario','OrigenFactura','EstadoRecurrencia', 'IdFacturaRecurrente']"
        :id-vista="idVista"
        :spanish="spanish"
        :data='data' 
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @actionclick='openPath'
        @datastatechange='dataStateChange'>
      </kendo-grid-component>
    </template>
    <template slot='layout-extend'>
      <base-footer>
        <template slot='actions'>
          <div class='mt-5 mb-5'></div>
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel'
            :loading="isGeneralLoading || loader" :disabled="loader" />
        </template>
      </base-footer>
      <base-table-select-actions-expand :baseDropDownVisible="isMoreActionsVisible" :visibility="hasSelected"
        :selected="rowsSelected" :total="rowsTotal">
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in accionesGeneral" :key="action.IdAccion">
            <base-button-item-list v-if="showAction(action)" theme="dark" @click="executeAction(action)">
              <base-icon :name="selectIcon(action.IdAccion)" class="mr-2" />
              <div class="w-72 text-left">
                {{ action.Descripcion }}
              </div>
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <Dialog :title="$t('invoices.send_invoice')" :visible.sync="showModal" width="40%" custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')"
              @click="() => { downloadHandler(); showModal = false }" />
          </div>
        </template>
      </Dialog>
      <Dialog :title="$t('invoices.delete_invoice')" :visible.sync="showModalDelete" width="40%" custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDelete
        }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModalDelete = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')"
              @click="() => { deleteHandler(); showModalDelete = false }" />
          </div>
        </template>
      </Dialog>
      <Dialog :title="$t('invoices.dialogs.delete_recurrence_header')" :visible.sync="showModalDeleteRecurrence" width="40%" custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDeleteRecurrence
        }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModalDeleteRecurrence = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')"
              @click="() => { deleteRecurrenceHandler(); showModalDeleteRecurrence = false }" />
          </div>
        </template>
      </Dialog>
      <Dialog :title="$t('groups.unlink_groups')" :visible.sync="showModalUnlinkGroups" width="40%" custom-class="min-width-dialog"
        center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageUnlinkGroups
        }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModalUnlinkGroups = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')"
              @click="() => { unlinkGroupsHandler(); showModalUnlinkGroups = false }" />
          </div>
        </template>
      </Dialog>
      <invoice-link-groups-dialog v-if="!isRoleProvider" :dialogOpen="showModalLinkGroups" multiple :idFacturae="firstIdFacturae"
        :idInvoice="firstIdInvoice" @toggleDialog="showModalLinkGroups = false"
        @applyDialog="(grupos) => { applyLinkHandler(grupos); showModalLinkGroups = false }" />
      <invoice-link-groups-dialog v-if="!isRoleProvider" :dialogOpen="showModalLinkGroupsReasig" :idFacturae="firstIdFacturae"
        :idInvoice="firstIdInvoice" @toggleDialog="showModalLinkGroupsReasig = false"
        @applyDialog="(grupos) => { applyLinkReasignHandler(grupos); showModalLinkGroupsReasig = false }" />
      <invoice-correction-dialog :dialogOpen="showCorrectionModal" :id-facturae="firstIdFacturae"
        :id-invoice="firstIdInvoice" @toggleDialog="toggleCorretionDialog" @applyDialog="applyCorretionDialog" />
      <invoice-recurrence-dialog :dialogOpen="showRecurrenceModal" :id-facturae="firstIdFacturae"
        :id-invoice="firstIdInvoice" :id-factura-recurrente="firstIdFacturaRecurrente" :editRecurrence="editRecurrencia" @toggleDialog="toggleRecurrenceDialog" @applyDialog="applyRecurrenceDialog" />
      <to-invoice-proforma-dialog :dialogOpen="showProformaModal" :id-facturae="firstIdFacturae" :id-invoice="firstIdInvoice"
        :to-proforma="toProforma" @toggleDialog="toggleProformaDialog" @applyDialog="applyProformaDialog" />
      <input-text-mail-from-white-list-dialog :dialogOpen="showModalWhiteMail" :id-cliente="idClienteSelected"
        :header="$t('invoices.dialogs.emails_dialog_header')" @toggleDialog="newWhiteMailToggleDialog" @applyDialog="applyNewWhiteMailDialog" />
      <!-- <link-my-groups-dialog :dialogOpen="showModalLinkMyGroups" :idCliente="idClienteSelected"
        @toggleDialog="linkMyGroupsToggleDialog" @applyDialog="applyLinkMyGroupsDialog" /> -->
      <filter-panel :panelOpen='filterPanel' @togglePanel='toggleFilters' @applyFilters='applyFiltersHandler'
        :status="status" />
      <create-search-dialog :numberSearches="numberSearches" :idVista="idVista" :dialogOpen="saveSearchDialog"
        :tags="tags" @toggleDialog="toggleDialogSearches" @applyDialog="applySearchHandler" />
      <filter-panel-searches ref="filterPanelSearches" :idVista="idVista" :vuexnamespace="vuexnamespace"
        :panelOpen="searchesPanel" @togglePanel="toggleSearchesDialog" @applyFilters="applyFiltersHandler"
        @updateNumberSearches="updateNumberSearches" />
    </template>
  </list-layout>
</template>

<script>
import { i18n } from '@/i18n'
import { load } from '@progress/kendo-vue-intl'
import { Dialog } from 'element-ui'
import { bus } from '@/main'

import InputTextMailFromWhiteListDialog from '@/components/InputTextMailFromWhiteListDialog.vue'
// import LinkMyGroupsDialog from '@/components/LinkMyGroupsDialog.vue'
import InvoiceLinkGroupsDialog from '@/components/InvoiceLinkGroupsDialog.vue'
import InvoiceCorrectionDialog from '@/components/InvoiceCorrectionDialog.vue'
import InvoiceRecurrenceDialog from '@/components/InvoiceRecurrenceDialog.vue'
import ToInvoiceProformaDialog from '@/components/ToInvoiceProformaDialog.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import FilterPanel from '@/components/filters/InvoicesFilter.vue'
import ListLayout from '@/components/layout/ListLayout.vue'

import { getInvoices } from '@/services/invoices/getInvoices'
import { getInvoicesExcel } from '@/services/invoices/getInvoicesExcel'
import { linkInvoicesGroupReasign } from '@/services/configurations/groups/linkInvoicesGroupReasign'
import { linkInvoiceGroupsMultiple } from '@/services/configurations/groups/linkInvoiceGroupsMultiple'
import { unlinkInvoiceGroupsMultiple } from '@/services/configurations/groups/unlinkInvoiceGroupsMultiple'
import { actualizarEstadoAccion } from '@/services/invoices/actualizarEstadoAccion'
import { sendAvisoCorreoManual } from '@/services/invoices/sendAvisoCorreoManual'
import { detenerFacturaRecurrente } from '@/services/invoices/detenerFacturaRecurrente'

import likelySubtags from 'cldr-core/supplemental/likelySubtags.json'
import currencyData from 'cldr-core/supplemental/currencyData.json'
import weekData from 'cldr-core/supplemental/weekData.json'
import numbers from 'cldr-numbers-full/main/es/numbers.json'
import currencies from 'cldr-numbers-full/main/es/currencies.json'
import caGregorian from 'cldr-dates-full/main/es/ca-gregorian.json'
import dateFields from 'cldr-dates-full/main/es/dateFields.json'
import timeZoneNames from 'cldr-dates-full/main/es/timeZoneNames.json'
// import moment from 'moment'

import { TIPOS_FILTER_MULTIPLE } from '@/config/tipos-filter-multiple'
// import _ from 'lodash'

load(
  likelySubtags,
  currencyData,
  weekData,
  numbers,
  currencies,
  caGregorian,
  dateFields,
  timeZoneNames
)

export default {
  name: 'invoices-issued-list-view',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    InvoiceLinkGroupsDialog,
    InvoiceCorrectionDialog,
    InvoiceRecurrenceDialog,
    ToInvoiceProformaDialog,
    // LinkMyGroupsDialog,
    InputTextMailFromWhiteListDialog,
    Dialog,
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 35,
      idVista: 40,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // Link grupos
      showCorrectionModal: false,
      showRecurrenceModal: false,
      showProformaModal: false,
      showModalLinkGroups: false,
      showModalUnlinkGroups: false,
      showModalLinkGroupsReasig: false,
      showModalLinkMyGroups: false,
      showModalWhiteMail: false,
      toProforma: false,
      // All
      multipleFilters: TIPOS_FILTER_MULTIPLE,
      estadosPorAccion: [],
      loader: false,
      spanish: true,
      nextStatus: null,
      header: {
        title: i18n.t('invoices.issued_header'),
        icon: 'issued',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'invoicesIssued',
      hasClientFilterData: false,
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
      listaAccionesCliente: [
        { IdAccion: 102, Descripcion: i18n.t('groups.reasig') },
        { IdAccion: 100, Descripcion: i18n.t('groups.link_groups') },
      ],
      listaAccionesComunes: [
        { IdAccion: 101, Descripcion: i18n.t('groups.unlink_groups') }
      ],
      listaAccionesRecurrentes: [
        { IdAccion: 26, Descripcion: i18n.t('tipos.accion.add_recurrence') },
        { IdAccion: 27, Descripcion: i18n.t('tipos.accion.edit_recurrence') },
        { IdAccion: 28, Descripcion: i18n.t('tipos.accion.delete_recurrente') },
      ],
      status: null,
      showModal: false,
      showModalDelete: false,
      showModalDeleteRecurrence: false,
      processMessage: i18n.t('invoices.dialogs.send_invoice_header'),
      processMessageDelete: i18n.t('invoices.dialogs.delete_invoice_header'),
      processMessageDeleteRecurrence: i18n.t('invoices.dialogs.delete_recurrence_dialog'),
      processMessageUnlinkGroups: i18n.t('app.unlink_all_entity_confirmation_f', { entity: i18n.t('groups.header').toLowerCase(), from: i18n.t('invoices.header').toLowerCase() }),
      selectedAction: null,
      invoicesActions: null,
      isNotice: false,
      noticeType: '',
    }
  },
  computed: {
    isRoleProvider: function () {
      return this.role === 9
    },
    isClientFilterActive () {
      return this.$store.getters[this.vuexnamespace + '/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterINav']
    },
    // editRecurrence () {
    //   return this.hasSelected ? this.selected[0].EstadoRecurrencia : null
    // },
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    isMoreActionsVisible: function () {
      return this.accionesGeneral !== undefined && this.accionesGeneral.length > 0
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.kendo.dataResult ? this.kendo.dataResult.data.length : 0
    },
    setLabelTowShow: function () {
      return this.showAllRows ? i18n.t('app.only_selected') : i18n.t('app.see_all')
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      var tags = this.$store.getters[this.vuexnamespace + '/getTags']
      if (this.status !== undefined && this.status !== 99999) {
        tags = tags.filter(x => x[0] !== 'estadoExtra')
        if (this.status !== 6) {
          tags = tags.filter(x => !['fechaRechazoDesde', 'fechaRechazoHasta', 'motivoRechazo'].includes(x[0]))
        }
        if (this.status !== 7) {
          tags = tags.filter(x => !['fechaPagoDesde', 'fechaPagoHasta'].includes(x[0]))
        }
      }
      return tags
      // return this.status === undefined || this.status === 99999 ? tags : tags.filter(x => x[0] !== 'estadoExtra')
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    selectIcon: function () {
      return (IdAccion) =>
        IdAccion === 3 ? 'trash'
          : IdAccion === 100 ? 'groupadd' // Manual
            : IdAccion === 101 ? 'groupremove' // Manual
              : IdAccion === 102 ? 'groupchange' // Manual
                : IdAccion === 200 ? 'download'
                  : IdAccion === 5 ? 'registrar'
                    : IdAccion === 6 ? 'aceptar'
                      : IdAccion === 7 ? 'contabilizar'
                        : IdAccion === 8 ? 'rechazar'
                          : IdAccion === 9 ? 'pagar'
                            : IdAccion === 10 ? 'anular'
                              : IdAccion === 11 ? 'pasarerror'
                                : IdAccion === 12 ? 'consultar'
                                  : IdAccion === 19 ? 'rectificar'
                                    : IdAccion === 20 ? 'acceptpresupuesto' 
                                      : IdAccion === 21 ? 'cancelproforma'
                                        : IdAccion === 22 ? 'convertproforma' 
                                          : IdAccion === 23 ? 'cancelproforma'
                                            : IdAccion === 24 ? 'facturar'
                                              : IdAccion === 25 ? 'mailsend' // Auto
                                                : 'changestatus'
    },
    firstInvoiceSelected () {
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) {
        return { 
          idFacturae: this.selected[0].idFacturae,
          idInvoice: this.selected[0].idInvoice, 
          IdFacturaRecurrente: this.selected[0].IdFacturaRecurrente,
          EstadoRecurrencia: this.selected[0].EstadoRecurrencia,
        } 
      }
      return 0
    },
    firstIdFacturae () {
      return this.firstInvoiceSelected?.idFacturae
    },
    firstIdInvoice () {
      return this.firstInvoiceSelected?.idInvoice
    },
    firstIdFacturaRecurrente () {
      return this.firstInvoiceSelected?.IdFacturaRecurrente
    },
    editRecurrencia () {
      return this.firstInvoiceSelected?.EstadoRecurrencia
    },
    prevRoutePath () { return this.prevRoute ? this.prevRoute.path : '/' },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isInvoicesGeneral: function () {
      return (this.status === undefined || this.status === 99999) && (this.noticeType === '' || this.noticeType === undefined)
    },
    // Genera las acciones posibles comunes de los elementos seleccionados
    accionesBySelected: function () {
      const objAcciones = { Acciones: [] }
      if (this.selected.length > 0) {
        this.estadosPorAccion.forEach(estadoPorAccion => {
          if (this.selected.length === this.selected.filter(x => estadoPorAccion.estados.includes(x.idEstado)).length) {
            objAcciones.Acciones.push({ Descripcion: estadoPorAccion.Descripcion, IdAccion: estadoPorAccion.IdAccion })
          }
        })
      }
      return objAcciones
    },
    userHasAllPermActions () {
      return [3, 8].includes(this.role)
    },
    // Generacion general de acciones
    accionesGeneral: function () {
      let acciones = []

      if (this.userHasAllPermActions || this.hasAllPropietariosByGroups(this.selected)) {
        // Si hay seleccion:
        if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) {
          // Comprobamos mismo cliente para añadir acciones comunes de cliente
          const idCliente = this.selected[0].idCliente
          if (this.selected.length === this.selected.filter(x => x.idCliente === idCliente).length) {
            // Añadimos las acciones comunes de cliente
            if (!this.isRoleUserOrConsulta) acciones = this.listaAccionesCliente
          }
          // Añadimos las acciones estaticas
          if (!this.isRoleUserOrConsulta) acciones = acciones.concat(this.listaAccionesComunes)
          acciones = acciones.concat(this.listaAccionesRecurrentes)
        }

        // Si no es consulta añadimos las acciones => Vista general: por seleccion, Vista de estado: por estado
        if (this.role !== 4) {
          if (this.isInvoicesGeneral) {
            acciones = acciones.concat(this.accionesBySelected.Acciones)
          } else {
            if (this.invoicesActions !== null && this.invoicesActions !== undefined) {
              acciones = acciones.concat(this.invoicesActions.Acciones)
            }
          }
        }
      } else {
        acciones = []
      }

      // Accion descarga local de adjuntos (para todos incluido Consulta)
      // if (this.selected.length === this.selected.filter(x => x.idEstado === 2 || x.idEstado === 7 || x.idEstado === 10 || x.idEstado === 11).length) acciones.push({ Descripcion: i18n.t('app.download_documents'), IdAccion: 200 })

      // Eliminamos borrar para rol Usuario y Consulta
      if (this.isRoleUserOrConsulta) acciones = acciones.filter(x => x.IdAccion !== 3)

      // Eliminamos Rectificar(Abono)   
      if (!this.hasModuleInterfazEmision) acciones = acciones.filter(x => x.IdAccion !== 19)
      
      return acciones
    },
    userGroups: function () {
      return this.$store.getters['auth/user']?.Grupos
    },
    idClienteSelected () {
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) {
        const idEmpresa = this.selected[0].idCliente
        if (this.selected.length === this.selected.filter(x => x.idCliente === idEmpresa).length) {
          return idEmpresa
        }
      }
      return -1
    },
    hasModuleInterfazEmision: function () {
      return !!this.$store.getters['auth/hasInterfazEmisionModule']
    },
  },
  watch: {
    // $route: 'routerChangeHandler',
    $route (to, from) {
      this.checkIsNotice(to, from)
      this.updateOnRouteChange(to, from)
      this.routerChangeHandler()
    },
    actualFilterNav: async function () {
      if (this.actualFilterNav === null || this.actualFilterNav === undefined || this.actualFilterNav === '') {
        await this.removeAllTagsHandler()
      }
    },
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  created: async function () {
    this.status = this.$route.meta.status
    this.$store.commit(this.vuexnamespace + '/setMenuType', this.status)

    if (this.$route.params.data) {
      this.filterByParamsData()
    }

    if (this.$route.meta && this.$route.meta.notice !== undefined && this.$route.meta.notice !== null) {
      this.isNotice = true
      this.noticeType = this.$route.meta.notice
      console.error(i18n.t('feedback.error.noticetype_not_found_error'))
    } else {
      this.isNotice = false
      this.noticeType = ''
      this.header.title = i18n.t('invoices.issued_header')
    }
    // this.kendo = this.$store.getters[this.vuexnamespace + '/getKendo']
  },
  mounted: async function () {
    this.status = parseInt(this.$store.getters[this.vuexnamespace + '/getMenuType'])
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)

    if (this.actualFilterNav && this.isClientFilterActive && !this.hasClientFilterData) {
      const filter = this.masterFilters
      filter.empresa = { label: i18n.t('clients.entity_name'), value: this.actualFilterNav }
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
    }

    if (this.status !== undefined && this.status !== 99999) {
      this.downloadInvoiceDataByStatus()
    } else {
      this.resetinvoicesActions()
      this.data = await this.applyFilters()
    }
    // await this.$store.dispatch('app/getInvoicesTypes')
  },
  methods: {
    hasAllPropietariosByGroups (invoices) {
      return invoices
        .every(x => this.userGroups
          .some(y => y.idGrupo === x.GrupoPropietario.idGrupo))
    },
    // Genera los estados por accion, de las acciones por estado
    generateEstadosPorAccion: function () {
      const estadosPorAccion = []
      this.invoicesActions.forEach(estadoAccion => {
        estadoAccion.Acciones.forEach(accion => {
          if (estadosPorAccion.filter(x => x.IdAccion === accion.IdAccion).length === 0) {
            const accionTMP = accion
            accionTMP.estados = []
            estadosPorAccion.push(accionTMP)
          }
          if (!estadosPorAccion.filter(x => x.IdAccion === accion.IdAccion)[0].estados.includes(estadoAccion.idEstado)) {
            estadosPorAccion.filter(x => x.IdAccion === accion.IdAccion)[0].estados.push(estadoAccion.idEstado)
          }
        })
      })
      this.estadosPorAccion = estadosPorAccion
    },
    applyLinkHandler: async function (grupos) {
      this.showModalLinkGroups = false
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idGrupos: [], idInvoiZEs: [] }
        payload.idGrupos = grupos
        payload.idInvoiZEs = this.selected.map(x => { return { idFacturae: x.idFacturae, idInvoice: x.idInvoice } })
        const response = await linkInvoiceGroupsMultiple(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_linked_msg'), 'success')
        }
        this.data = await this.applyFilters()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyLinkReasignHandler: async function (grupo) {
      this.showModalLinkGroupsReasig = false
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idInvoiZEs: [], idGrupo: grupo }
        payload.idInvoiZEs = this.selected.map(x => { return { idFacturae: x.idFacturae, idInvoice: x.idInvoice } })
        const response = await linkInvoicesGroupReasign(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_reasigned_msg'), 'success')
        }
        this.data = await this.applyFilters()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyCorretionDialog: async function (event) {
      this.toggleCorretionDialog()
    },
    applyRecurrenceDialog: async function (event) {
      this.data = await this.applyFilters()
      this.unselect()
      this.toggleRecurrenceDialog()
    },
    applyProformaDialog: async function (event) {
      this.data = await this.applyFilters()
      this.toggleProformaDialog()
    },
    toggleDialogs: function () {
      if (this.showModalLinkGroups) return
      this.showModalLinkGroups = !this.showModalLinkGroups
    },
    toggleDialogReasign () {
      if (this.showModalLinkGroupsReasig) return
      this.showModalLinkGroupsReasig = !this.showModalLinkGroupsReasig
    },
    toggleCorretionDialog: function () {
      this.showCorrectionModal = !this.showCorrectionModal
    },
    toggleRecurrenceDialog: function () {
      this.showRecurrenceModal = !this.showRecurrenceModal
    },
    toggleProformaDialog: function () {
      this.showProformaModal = !this.showProformaModal
    },
    newWhiteMailToggleDialog () {
      this.showModalWhiteMail = !this.showModalWhiteMail
    },
    linkMyGroupsToggleDialog () {
      this.showModalLinkMyGroups = !this.showModalLinkMyGroups
    },
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'company') {
            const cif = { label: i18n.t('companies.companyName'), value: filter.data.label }
            filters.NombreCIF = cif
          } else if (filter.type === 'cliente') {
            this.hasClientFilterData = true
            const cliente = { label: i18n.t('clients.entity_name'), value: { Nombre: filter.data.label, idCliente: filter.data.id } }
            filters.empresa = cliente
          } else {
            filters[filter.type] = filter.data
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    checkIsNotice: function (to, from) {
      if (to.meta && to.meta.notice !== undefined) {
        this.isNotice = true
        this.noticeType = to.meta.notice
        console.error(i18n.t('feedback.error.noticetype_not_found_error'))
      } else {
        this.isNotice = false
        this.noticeType = ''
        this.header.title = i18n.t('invoices.issued_header')
      }
    },
    updateOnRouteChange: async function (to, from) {
      this.status = parseInt(to.meta.status)
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setMenuType', this.status)
      // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      // this.$store.commit(this.vuexnamespace + '/resetPaginationInfo')
      if (to.meta && to.meta.status !== undefined && to.meta.status !== 99999) {
        this.downloadInvoiceDataByStatus()
      } else {
        this.data = await this.applyFilters()
      }
    },
    routerChangeHandler: function (to, from) {
      this.resetinvoicesActions()
      if (this.status !== undefined && this.status !== 99999) {
        this.invoicesActions = this.$store.getters['app/actionsForSelect'](this.status, 'Emitida')
      } else {
        this.resetinvoicesActions()
      }
    },
    resetinvoicesActions: function () {
      this.invoicesActions = this.$store.getters['app/actionsForSelect'](null, 'Emitida')
      this.generateEstadosPorAccion() // Necesario para logica automatica de compatibilidad de acciones
    },
    openPath: function (event) {
      this.$store.commit('app/setheaderBreadCrumb', event.dataItem.NumFactura)
      const status = this.status === 99999 ? event.dataItem.idEstado : this.status
      this.$router.push(
        {
          name: 'invoicesissued/details',
          params: {
            // id: event.dataItem.IDInterno, 
            idFacturae: event.dataItem.idFacturae,
            idInvoice: event.dataItem.idInvoice,
            type: status,
            asunto: event.dataItem.NumFactura,
            notice: this.noticeType,
            fromGeneral: this.status === 99999 || this.status === '99999',
          }
        }
      )
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    getParamsFilter (data) {
      return {
        fechaFacturaDesde: data.fechaFacturaDesde ? data.fechaFacturaDesde.value : null,
        fechaFacturaHasta: data.fechaFacturaHasta ? data.fechaFacturaHasta.value : null,
        fechaTicketBaiHasta: data.fechaTicketBaiHasta ? data.fechaTicketBaiHasta.value : null,
        fechaTicketBaiDesde: data.fechaTicketBaiDesde ? data.fechaTicketBaiDesde.value : null,
        tipoInvoiceClass: data.tipoInvoiceClass ? data.tipoInvoiceClass.value : null,
        pge: data.pge ? data.pge.value : null,
        importeMinimo: data.importeDesde ? data.importeDesde.value : null,
        importeMaximo: data.importeHasta ? data.importeHasta.value : null,
        numFactura: data.numFactura ? data.numFactura.value : null,
        SerieFactura: data.SerieFactura ? data.SerieFactura.value : null,
        cifEmisor: data.cifEmisor ? data.cifEmisor.value : null,
        nombreCIFEmisor: data.NombreCIFEmisor ? data.NombreCIFEmisor.value : null,
        cifReceptor: data.cifReceptor ? data.cifReceptor.value : null,
        nombreCIFReceptor: data.NombreCIFReceptor ? data.NombreCIFReceptor.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value.idCliente : null,
        comentarios: data.notas ? data.notas.value : null,
        importe: data.importe ? data.importe.value : null,
        nombreGrupo: data.nombreGrupo ? data.nombreGrupo.value : null,
        nombreGrupoPropietario: data.nombreGrupoPropietario ? data.nombreGrupoPropietario.value : null,
        ultimoError: data.ultimoError ? data.ultimoError.value : null,
        MotivoRechazo: data.motivoRechazo ? data.motivoRechazo.value : null,
        fechaAltaDesde: data.fechaAltaDesde ? data.fechaAltaDesde.value : null,
        fechaAltaHasta: data.fechaAltaHasta ? data.fechaAltaHasta.value : null,
        fechaPagoDesde: data.fechaPagoDesde ? data.fechaPagoDesde.value : null,
        fechaPagoHasta: data.fechaPagoHasta ? data.fechaPagoHasta.value : null,
        fechaRechazoDesde: data.fechaRechazoDesde ? data.fechaRechazoDesde.value : null,
        fechaRechazoHasta: data.fechaRechazoHasta ? data.fechaRechazoHasta.value : null,
        agrupacionCIF: data.agrupacionCIF ? data.agrupacionCIF.value : null,
        csv: data.csv ? data.csv.value : null,
        recibidas: false,
        contieneAdjuntos: data.contieneAdjuntos ? data.contieneAdjuntos.value : null,
        estadoTicketbai: data.estadoTicketbai ? data.estadoTicketbai.value : null,
        IdTBAI: data.IdTBAI ? data.IdTBAI.value : null,
        OrigenFactura: data.OrigenFactura ? data.OrigenFactura.value : null,
        estadoRecurrencia: data.EstadoRecurrencia ? data.EstadoRecurrencia.value : null,
        idFacturaRecurrente: data.IdFacturaRecurrente ? data.IdFacturaRecurrente.value : null
      }
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loader = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = this.getParamsFilter(data)
      const orders = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = {
        order: orders.order,
        grupos: objColumnas,
      }

      // Filtros multiples casos especiales
      const estadosFilter = (this.status !== undefined && this.status !== 99999) ? this.status : data.estadoExtra ? data.estadoExtra.value : null
      if (Array.isArray(estadosFilter)) {
        payload.estadosFacturas = estadosFilter
      } else {
        params.estado = estadosFilter
        if ((this.status !== undefined && this.status !== 99999)) {
          if (estadosFilter !== 6) {
            params.fechaRechazoDesde = null
            params.fechaRechazoHasta = null
            params.MotivoRechazo = null
          }
          if (estadosFilter !== 7) {
            params.fechaPagoDesde = null
            params.fechaPagoHasta = null
          }
        }
      }
      // const sedesFilter = data.codPGN ? data.codPGN.value : null
      // if (Array.isArray(sedesFilter)) {
      //   payload.codPGNs = sedesFilter
      // } else {
      //   params.codPGN = sedesFilter
      // }

      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => {
          return {
            idFacturae: x.idFacturae,
            idInvoice: x.idInvoice,
          }
        })
        payload.listaIDs = selectedIDs
      }
      let response
      try {
        if (!this.isNotice) {
          response = await getInvoicesExcel(payload, params)
        }
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'facturas-emitidas.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loader = false
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      this.$store.commit('setIsLoading', true)
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      this.$store.commit(this.vuexnamespace + '/setClientFilterActive', !!((data.empresa && data.empresa.value.idCliente === this.actualFilterNav?.idCliente) || (this.hasClientFilterData)))
      const params = this.getParamsFilter(data)
      const obj = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)

      // Filtros multiples casos especiales
      const estadosFilter = (this.status !== undefined && this.status !== 99999) ? this.status : data.estadoExtra ? data.estadoExtra.value : null
      if (Array.isArray(estadosFilter)) {
        obj.estadosFacturas = estadosFilter
      } else {
        params.estado = estadosFilter
        if ((this.status !== undefined && this.status !== 99999)) {
          if (estadosFilter !== 6) {
            params.fechaRechazoDesde = null
            params.fechaRechazoHasta = null
            params.MotivoRechazo = null
          }
          if (estadosFilter !== 7) {
            params.fechaPagoDesde = null
            params.fechaPagoHasta = null
          }
        }
      }
      if (data.metadatos?.value?.length) {
        obj.metadatos = data.metadatos?.value
      }

      try {
        const data = await this.getItemsData(obj, params)
        return data
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      return null
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      const data = res.respuesta

      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false

      if (pagination.currentPage > pagination.totalPages) {
        this.applyFiltersHandler()
      }

      return data
    },
    async getMainData (orders, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getInvoices(orders, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      data.respuesta.forEach(o => {
        // o.FechaFactura = moment(o.FechaFactura).format('DD-MM-YYYY HH:mm')
      })
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters()
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      try {
        this.data = await this.applyFilters()
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    removeFilterTagHanlder: async function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const index = tag.at(-1)
      const tagName = this.multipleFilters.find(x => new RegExp('^' + x.NombreTag + '\\d*$').test(tag[0]))?.NombreTag
      if (tagName) {
        if (Number.isInteger(index) && Array.isArray(filter[tagName].value) && index > -1 && 
          index < filter[tagName]?.value.length && filter[tagName]?.value.length > 1) {
          filter[tagName].value.splice(index, 1)
        } else {
          delete filter[tagName]
        }
      } else {
        delete filter[tag[0]]
      }
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.data = await this.applyFilters()
    },
    headerCoreFiltersHandler: async function (obs) {
      if (this.isHeadCoreReady) {
        this.data = await this.applyFilters()
      }
    },
    removeAllTagsHandler: async function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.data = await this.applyFilters()
    },
    unselect: function () {
      this.selected = []
    },
    download: async function () {
      this.showModal = !this.showModal
    },
    downloadHandler: async function () {
      this.executeActionHandler()
    },
    deleteHandler: async function () {
      this.executeActionHandler()
    },
    deleteRecurrenceHandler: async function () {
      const selected = this.firstIdFacturaRecurrente
      try {
        this.$store.commit('setIsLoading', true)
        const response = await detenerFacturaRecurrente({ idFacturaRecurrente: selected })
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.data = await this.applyFilters()
          this.unselect()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    unlinkGroups: async function () {
      this.showModalUnlinkGroups = !this.showModalUnlinkGroups
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 1) { // enviar
        this.showModal = true
      } else if (this.selectedAction.IdAccion === 3) { // borrar
        this.showModalDelete = true
      } else if (action.IdAccion === 19) { // Rectificativa
        this.showCorrectionModal = !this.showCorrectionModal
      } else if (action.IdAccion === 22 || action.IdAccion === 24) {
        this.toProforma = action.IdAccion === 22
        this.showProformaModal = !this.showProformaModal
      } else if (this.selectedAction.IdAccion === 25) { // Enviar aviso email a elección
        this.newWhiteMailToggleDialog()
      } else if (this.selectedAction.IdAccion === 26 || this.selectedAction.IdAccion === 27) { // Asignar recurrente || Editar recurrente
        this.showRecurrenceModal = !this.showCorrectionModal
      } else if (this.selectedAction.IdAccion === 28) { // Terminar recurrencia
        this.showModalDeleteRecurrence = true
      } else if (this.selectedAction.IdAccion === 100) { // vincular grupos
        this.toggleDialogs()
      } else if (this.selectedAction.IdAccion === 101) { // desvincular grupos
        this.unlinkGroups()
      } else if (this.selectedAction.IdAccion === 102) { // Reasignar propietario a grupo
        this.toggleDialogReasign()
      } else {
        this.executeActionHandler()
      }
    },
    executeActionHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)

        const selected = this.selected
        const idAccion = this.selectedAction.IdAccion
        const data = {
          idAccion,
          facturasCambio: [],
        }
        selected.forEach(x => {
          data.facturasCambio.push({
            IdInvoice: x.idInvoice,
            IdFacturae: x.idFacturae,
            Estado: x.idEstado,
          })
        })

        const response = await actualizarEstadoAccion(data)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.selected = []
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.downloadInvoiceDataByStatus()
        bus.$emit('changeIt', 'changed menu')
      }
    },
    downloadInvoiceDataByStatus: async function () {
      // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      try {
        const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
        filter.estado = { label: i18n.t('app.status'), value: this.status }

        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
        this.invoicesActions = this.$store.getters['app/actionsForSelect'](this.status, 'Emitida')
        if (this.status !== undefined && this.status !== 99999) {
          this.header.title = this.invoicesActions.InfoAdicional
        }
        this.data = await this.applyFilters()
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyNewWhiteMailDialog: async function (form) {
      if (form.GestionarListaBlancaGrupos) {
        this.auxGroupsMail = {
          valueTo: form.valueTo,
          valueCC: form.valueCC,
          valueCCO: form.valueCCO,
          TextoCorreo: form.TextoCorreo,
          AsuntoCorreo: form.AsuntoCorreo,
        }
        this.linkMyGroupsToggleDialog()
      } else {
        this.newWhiteMailDialogHandler(form)
      }
      this.showModalWhiteMail = false
    },
    applyLinkMyGroupsDialog (grupos) {
      this.newWhiteMailDialogHandler(this.auxGroupsMail, grupos)
    },
    newWhiteMailDialogHandler: async function (emails, grupos) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          Emails: emails.valueTo.split(';').map(x => x.trim()).filter(x => !!x), 
          EmailsCC: emails.valueCC.split(';').map(x => x.trim()).filter(x => !!x), 
          EmailsCCO: emails.valueCCO.split(';').map(x => x.trim()).filter(x => !!x), 
          listaIDs: this.selected.map(x => ({ IdFacturae: x.idFacturae, IdInvoice: x.idInvoice })),
          idGrupos: grupos || null,
          TextoCorreo: emails.TextoCorreo || null,
          AsuntoCorreo: emails.AsuntoCorreo || null,
        }
        const response = await sendAvisoCorreoManual(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.showModalLinkMyGroups = false
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.data = await this.applyFilters()
      }
    },
    unlinkGroupsHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        for (const element of this.selected) {
          payload.push({ idFacturae: element.idFacturae, idInvoice: element.idInvoice })
        }
        const response = await unlinkInvoiceGroupsMultiple(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
    showAction: function (action) {
      switch (action.IdAccion) {
        case 12:
          return !this.selected.some(x => x.PgeKey === 'EXTERNO')

        case 19: 
        case 22: 
        case 24: 
          return this.selected.length === 1

        case 26:
          if (this.selected.length === 1) return this.selected[0].OrigenFactura === 'EMISION' && !this.selected[0].EstadoRecurrencia 
          break
        case 27:
        case 28:
          if (this.selected.length === 1) return this.selected[0].EstadoRecurrencia
          break 
        default:
          return true
      }
    },
  }
}
</script>

<style lang='scss' scoped></style>
